<template>
  <div class="c-amenities-list">
    <i
      v-for="a in availableAmenities"
      class="js-tooltip mr-3"
      :key="a.name"
      :class="a.icon"
      :data-tooltip-content="$t('expedia.' + a.name)"
      data-tooltip-placement="top"
    ></i>
  </div>
</template>

<script>
import FilterHelper from "@/helpers/filters.helper.js";
export default {
  name: "AmenitiesLabel",
  props: {
    amenities: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      primeAmenities: []
    };
  },
  created() {
    this.primeAmenities = FilterHelper.getPrimeAmenities().filter(
      (a) => a.icon
    );
  },
  computed: {
    availableAmenities() {
      // Filter primeAmenities to include only those that are available
      return this.primeAmenities.filter((a) => this.hasAmenity(a));
    }
  },
  methods: {
    hasAmenity(a) {
      if (a.name.indexOf("_AVAILABLE") > -1) {
        let altName = a.name.replace("_AVAILABLE", "_INCLUDED");
        if (a.name.indexOf("PARK") > -1) {
          return (
            this.amenities?.indexOf(a.name) > -1 ||
            this.amenities?.indexOf(altName) > -1 ||
            this.amenities?.indexOf("FREE_PARKING") > -1
          );
        } else {
          return (
            this.amenities?.indexOf(a.name) > -1 ||
            this.amenities?.indexOf(altName) > -1
          );
        }
      } else {
        return this.amenities?.indexOf(a.name) > -1;
      }
    }
  }
};
</script>
